let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("glSHX")).then(() => parcelRequire('62Ipf'));